import { CARGO_TYPE_ID, RateCardType } from '@types';

export const rateCardTypeFromCargoTypeId = (cargoTypeId: number): RateCardType | 'VOLUME' |'' => {
	switch (cargoTypeId) {
	case CARGO_TYPE_ID.FullTruckload:
		return 'FULL_LOAD';
	case CARGO_TYPE_ID.Pallets:
		return 'PALLETS';
	case CARGO_TYPE_ID.Volumetric:
		return 'VOLUME';
	case CARGO_TYPE_ID.Loose:
		return 'WEIGHT';
	// Bundle and Skid are priced the same way as Other (see OTHER_FAMILY_CARGO_TYPES in buildEOSShipmentSchema.ts).
	case CARGO_TYPE_ID.Other:
	case CARGO_TYPE_ID.Bundle:
	case CARGO_TYPE_ID.Skid:
		return 'CPK';
	case CARGO_TYPE_ID.CustomItem:
		return 'ITEM';
	default:
		return '';
	}
};
